import { Box } from "@chakra-ui/react";
import { Navbar } from "../components/landing/Navbar";
import { Footer } from "../components/landing/Footer";
import { FundDetail } from "../components/funds/FundDetail";

export const FundDetailPage = () => {
  return (
    <Box dir="rtl" overflowX="hidden">
      <Navbar />
      <FundDetail />
      <Footer />
    </Box>
  );
};
